/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var AppInstallInProgressIcon = createIcon("AppInstallInProgressIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#0045DB';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M16.295 10.682a7.615 7.615 0 01-.725 1.899m-1.36 1.773a8.113 8.113 0 01-1.637 1.207M9.662 1.498a7.4 7.4 0 011.98.455m1.95 1.09a7.21 7.21 0 011.42 1.452m1.055 1.972a7 7 0 01.409 1.989M10.5 16.315a7.503 7.503 0 01-3-14.7M9 6.188v5.625",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375 9.188 9 11.812l2.625-2.624",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});